import { hasLongBuildPumps } from './dataProcessing';

/**
 * Function to gather all necessary data for job notices
 * @param {Object} job - The job object
 * @param {Array} pumpDetails - Array of pump details for long build detection
 * @returns {Object} - Consolidated notice data
 */
export const getJobNoticeData = (job, pumpDetails = []) => {
  if (!job) {
    return {
      hasNotices: false,
      notices: {}
    };
  }

  const notices = {};
  let hasNotices = false;

  // TBD Notice Data
  if (job.ID) {
    notices.tbd = {
      hasNotice: true,
      jobId: job.ID
    };
    hasNotices = true;
  }

  // Witness Test Notice Data
  if (job.WitnessTestRequired === 'Yes') {
    notices.witnessTest = {
      hasNotice: true,
      required: job.WitnessTestRequired,
      testDate: job.WitnessTestDate,
      testCriteria: job.TestCriteria,
      complianceCertificateRequired: job.ComplianceCertificateRequired,
      comments: job.WitnessTestComments
    };
    hasNotices = true;
  }

  // Move Request Notice Data
  if (job.MoveRequestDateInitiated) {
    notices.moveRequest = {
      hasNotice: true,
      dateInitiated: job.MoveRequestDateInitiated,
      requestedDate: job.MoveRequestRequestedDate,
      reason: job.MoveRequestReason,
      status: job.MoveRequestStatus,
      approvedBy: job.MoveRequestApprovedBy,
      comments: job.MoveRequestComments
    };
    hasNotices = true;
  }

  // Long Build Notice Data
  let longBuildData = {
    hasNotice: false,
    tplValue: null
  };

  // First try with pump details
  const longBuildResult = hasLongBuildPumps(job, pumpDetails);
  if (longBuildResult.hasLongBuild) {
    longBuildData = {
      hasNotice: true,
      tplValue: longBuildResult.tplValue,
      source: 'pumpDetails'
    };
    hasNotices = true;
  } 
  // Fallback: Try to extract from ModelNumber if no pump details
  else if ((!pumpDetails || pumpDetails.length === 0) && job.ModelNumber) {
    const modelNumber = job.ModelNumber;
    let extractedTPL = null;
    
    // Pattern 1: Look for numbers after "TPL" or similar
    let tplMatch = modelNumber.match(/TPL[^\d]*(\d+)/i);
    if (tplMatch) {
      extractedTPL = parseInt(tplMatch[1]);
    }
    
    // Pattern 2: Look for specific format in VT pump model numbers
    if (!extractedTPL) {
      tplMatch = modelNumber.match(/-(\d{2,3})$/);
      if (tplMatch) {
        const potential = parseInt(tplMatch[1]);
        if (potential >= 30 && potential <= 300) {
          extractedTPL = potential;
        }
      }
    }
    
    // Consider it long build if TPL >= 60
    if (extractedTPL && extractedTPL >= 60) {
      longBuildData = {
        hasNotice: true,
        tplValue: extractedTPL,
        source: 'modelNumber'
      };
      hasNotices = true;
    }
  }

  if (longBuildData.hasNotice) {
    notices.longBuild = longBuildData;
  }

  return {
    hasNotices,
    notices,
    jobInfo: {
      id: job.ID,
      jobNumber: job.JobNumber,
      projectName: job.ProjectName,
      modelNumber: job.ModelNumber
    }
  };
};

/**
 * Hook version for use in React components
 * @param {Object} job - The job object
 * @param {Array} pumpDetails - Array of pump details for long build detection
 * @returns {Object} - Consolidated notice data
 */
export const useJobNoticeData = (job, pumpDetails = []) => {
  return getJobNoticeData(job, pumpDetails);
};